import { z } from 'zod';
import {
  annotationPartnerZod,
  annotationStateZod,
  mediaTypeZod,
  pipelineZodWithCatch,
  taskGroupStateZod,
  taskGroupTypes,
  taskGroupTypeZod,
  taskStateZod,
} from 'packages/lib/api/annotations/contract/enums';
import { dispatchWarningToast } from 'packages/lib/common-ui/toast/api-toast';

export const taskGroupZod = z.object({
  token: z.string(),
  sampleGroupToken: z.nullable(z.string()),
  taskTypeToken: z.nullable(z.string()), // swagger lies
  taskGroupTypeToken: z.nullable(z.string()),
  pipelineToken: z.string(),
  name: z.nullable(z.string()),
  description: z.nullable(z.string()),
  comment: z.nullable(z.string()),
  tag: z.nullable(z.string()),
  acceptedAt: z.nullable(z.string().datetime()),
  startedAt: z.nullable(z.string().datetime()),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  taskStats: z.nullable(z.record(taskStateZod, z.number())),
  partner: annotationPartnerZod,
  type: taskGroupTypeZod.catch(({ error, input }) => {
    if (typeof input === 'string') {
      dispatchWarningToast(
        `"${input}" is not a registered TaskGroupType, but the error has been automatically handled. Please report this issue to the Annotation Tools team.`,
        false
      );
      return input as (typeof taskGroupTypes)[number];
    }
    throw error;
  }),
  state: taskGroupStateZod,
  stats: z.optional(z.record(annotationStateZod, z.number())),
  pipeline: pipelineZodWithCatch,
  mediaType: mediaTypeZod,
});

export const taskGroupsRespZod = z.array(taskGroupZod);

export type TaskGroupsResp = z.infer<typeof taskGroupsRespZod>;
export type TaskGroup = z.infer<typeof taskGroupZod>;
